'use strict';

angular.module('adminEmailTemplatesRoutes', ['adminEmailTemplatesControllers',
                                             'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('adminEmailTemplates', {
            url: '/Administration/EmailTemplates',
            views: {
                '': {
                    templateUrl: require('./MainEmailTemplates.tpl.html'),
                    controller: 'MainEmailTemplatesController',
                    resolve: {
                        authenticatedUser: ['authenticatedUserService', function (service) {
                            return service.getAuthenticatedUser();
                        }]
                    }
                },
                'sidebar@adminEmailTemplates': {
                    templateUrl: require('./SideBar.tpl.html'),
                    controller: 'EmailTemplateSideBarController',
                    resolve: {
                        emailTemplates: ['adminEmailTemplatesService', function (service) {
                            return service.getEmailTemplates();
                        }]
                    }
                }
            }
        })

        .state('adminEmailTemplates.emailTemplate', {
            url: '/{emailTemplateCode}',
            views: {
                'details@adminEmailTemplates': {
                    templateUrl: require('./EmailTemplate.tpl.html'),
                    controller: 'EmailTemplateController',
                    resolve: {
                        emailTemplate: ['adminEmailTemplatesService', '$stateParams', function (service, $stateParams) {
                            return service.getEmailTemplateByCode($stateParams.emailTemplateCode);
                        }]
                    }
                }
            }
        })

        // Iframe to edit content template 
        .state('editEmailTemplate', {
            url: '/Administration/EmailTemplate/Edit/{emailTemplateCode}',
            templateUrl: require('./EditEmailTemplate.tpl.html'),
            controller: 'EditEmailTemplateController',
            resolve: {
                emailTemplate: ['adminEmailTemplatesService', '$stateParams', function (service, $stateParams) {
                    return service.getEmailTemplateByCode($stateParams.emailTemplateCode);
                }]
            }
        });
}]);